import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "store";
import { clearSession } from "store/slices/auth/auth.slice";
import { CgDanger } from "react-icons/cg";

// pages/Authentication/Unauthorized.tsx
interface UnauthorizedProps {
  title?: string;
  description?: string;
  subDescription?: string;
  showSignIn?: boolean;
  onGoBack?: () => void;
}

export default function Unauthorized({
  title = "Access Denied",
  description = "You don't have permission to access this workspace.",
  subDescription = "This workspace belongs to a different organization than your current session.",
  showSignIn = true,
  onGoBack
}: UnauthorizedProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const returnUrl = searchParams.get("returnUrl");

  return (
    <div className="min-h-screen bg-primary flex items-center justify-center px-4">
      <div className="bg-primary-intemediate border border-[#222735] rounded-2xl p-10 max-w-md w-full text-center">
        
        {/* Icon */}
        <div className="w-16 h-16 rounded-full  flex items-center justify-center mx-auto mb-6">
          <CgDanger className="text-red-500" size={50} />
        </div>

        <h1 className="text-xl font-semibold text-white mb-2">
          {title}
        </h1>
        <p className="text-sm text-gray-400 mb-2">
          {description}
        </p>
        {subDescription && (
          <p className="text-xs text-gray-500 mb-8">
            {subDescription}
          </p>
        )}

        <div className="flex flex-col gap-3">
          <button
            onClick={onGoBack || (() => navigate(-1))}
            className="w-full h-[46px] rounded-lg border border-[#374151] text-sm text-gray-300 hover:bg-[#1E2230] transition-colors"
          >
            Go Back
          </button>
          
          {showSignIn && (
            <button
              onClick={() => {
                dispatch(clearSession());
                navigate(returnUrl ? `/login?returnUrl=${encodeURIComponent(returnUrl)}` : '/login', { replace: true });
              }}
              className="w-full h-[46px] rounded-lg bg-[#6366F1] text-white text-sm font-medium hover:bg-[#4F46E5] transition-colors"
            >
              Sign in to this Workspace
            </button>
          )}
        </div>
      </div>
    </div>
  );
}